export const cardSx = (theme) => ({
  maxWidth: '600px',
  minWidth: '345px',
  [theme.breakpoints.between('xs', 'md')]: {
    width: '100%',
  },
  [theme.breakpoints.up('md')]: {
    width: '600px',
  },
  backgroundColor: theme.palette.background.secondary,
  marginBottom: '16px',
  border: `1px solid ${theme.palette.accent.main}`,
  borderRadius: 0,
});

export const avatarSx = (theme) => ({ bgcolor: theme.palette.quaternary.main });

export const titleSx = (theme) => ({
  '.MuiCardHeader-title': {
    color: theme.palette.secondary.main,
    fontWeight: 700,
  },
});

export const cardContentSx = (theme) => ({
  borderBottom: `1px solid ${theme.palette.accent.main}`,
  padding: '0px 16px 16px 16px',
});

export const timeSx = { fontSize: '14px', color: '#71767b' };
